export enum ClaimantInformationFormPlaceholdersEnum {
  CUSTOMER_MAD_CODE = 'KOHLR001900',
}
